import React from "react";
import loadable from "@loadable/component";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";
const HolderOrderListComponent = loadable(
  () => import("../../components/HoldOrder/HoldOrderList")
);

const HoldOrderList = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["hold-order"],
    navigateURL: "",
  });
  const [searchParams, setSearchParams] = useSearchParams();
  const handleRemove = async (setError: any) => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",");
    if (!selectedOrder) {
      toast.error("Please select at least one order first");
      return;
    }
    const url = `${APIS.ORDER}hold/`;
    let formData = {
      order_ids: selectedOrder,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 200) {
        searchParams.delete("selectedItems");
        setSearchParams(searchParams);
      }
    } catch (err) {
      toast.success("Somethings went wrong");
    }
  };
  return (
    <>
      <HolderOrderListComponent
        handleRemove={handleRemove}
        isLoading={isPostLoading}
      />
    </>
  );
};

export default HoldOrderList;
